// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"1cf87f7a","278":"ed23df81","467":"8a769502","799":"809a5b0f","843":"ac7ccbf4","879":"99787460","941":"69ddb476"}[chunkId] + ".chunk.js";
};